// test1665
(1665 && 0);
